import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { CommonModule } from "@angular/common";
import { FooterComponent } from "src/app/components/footer/footer.component";
import { HeaderComponent } from "src/app/components/header/header.component";
import { TitleSectionComponent } from "../components/title-section/title-section.component";
import { OwlModule } from "ngx-owl-carousel";
import { OurBlogComponent } from "../components/our-blog/our-blog.component";
import { BlogOwlComponent } from "../components/our-blog/blog-owl/blog-owl.component";
import { WorkingLanguageComponent } from "../components/working-language/working-language.component";
import { RouterModule } from "@angular/router";
import { HelpComponent } from "../components/help/help.component";
import { PlanComponent } from "../components/plan/plan.component";
import { OurPartnersComponent } from "../components/our-partners/our-partners.component";
import { PartnersComponent } from "../components/our-partners/partners/partners.component";
import { AuthComponent } from "../components/login/auth/auth.component";
import { OurServicesComponent } from "../components/our-services/our-services.component";
import { CounterComponent } from "../components/counter/counter.component";
import { OurClientsComponent } from "../components/our-clients/our-clients.component";
import { FormsModule } from "@angular/forms";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { OurClientsIconsComponent } from "../components/our-clients-icons/our-clients-icons.component";
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
@NgModule({
    declarations: [
        HeaderComponent,
        FooterComponent,
        TitleSectionComponent,
        OurBlogComponent,
        BlogOwlComponent,
        WorkingLanguageComponent,
        HelpComponent,
        PlanComponent,
        OurPartnersComponent,
        PartnersComponent,
        AuthComponent,
        OurServicesComponent,
        CounterComponent,
        OurClientsComponent,
        OurClientsIconsComponent
    ],
    imports: [
        MatProgressSpinnerModule,
        MatSnackBarModule,
        HttpClientModule,
        CommonModule,
        FormsModule,
        RouterModule,
        OwlModule,
        MatTooltipModule,
        MatSlideToggleModule,
        MatButtonToggleModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
        }),
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA
    ],
    exports:[
        HeaderComponent,
        FooterComponent ,
        TitleSectionComponent,
        OurBlogComponent,
        BlogOwlComponent,
        WorkingLanguageComponent,
        HelpComponent,
        PlanComponent,
        OurPartnersComponent,
        PartnersComponent,
        AuthComponent,
        OurServicesComponent,
        CounterComponent,
        OurClientsComponent,
        OurClientsIconsComponent
    ]
  })
  export class SharedModule { }
    export function createTranslateLoader(http: HttpClient) {
        return new TranslateHttpLoader(http, './assets/i18n/', '.json');
  }